import React from "react"
import Styles from "./styles/BlogTagsStyle.module.styl"
import BlogListWrapper from "../../blogList/components/shared/blogListWrapper/BlogListWrapper"
import NewestBlogList from "../../blogList/components/shared/newestBlogList/NewestBlogList"
import NewestBlogListStyle from "../../blogList/components/shared/newestBlogList/NewestBlogListStyle.module.styl"
import BlogListCategories from "../../blogList/components/shared/blogListCategories/BlogListCategories"
import BlogListWrapperStyle from "../../blogList/components/shared/blogListWrapper/BlogListWrapperStyle.module.styl"
import MostReadBlogs from "../../blogList/components/shared/mostReadBlogs/MostReadBlogs"

class BlogTags extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      path: "path",
      width: 0,
      subCategoriesDropdown: false,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener("resize", this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    let path = window.location.pathname.slice(1)
    let place = path.search("/", path)
    let result =
      path === "" ? "/" : window.location.pathname.slice(0, place + 50)
    this.setState({ path: result, width: window.innerWidth })
  }
  shuffle = a => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[a[i], a[j]] = [a[j], a[i]]
    }
    return a
  }

  toggleSubCategoriesDropdown = () => {
    this.setState({ subCategoriesDropdown: !this.state.subCategoriesDropdown })
  }

  render() {
    const { path, width, subCategoriesDropdown } = this.state
    const { data, mostReadBlogs, categories } = this.props
    let uniqueResultOne =
      data.posts &&
      data.posts.filter(function (obj) {
        return !mostReadBlogs.some(function (obj2) {
          return obj.id === obj2.node.id
        })
      })

    let uniqueResultTwo = mostReadBlogs.filter(function (obj) {
      return (
        data.posts &&
        !data.posts.some(function (obj2) {
          return obj.node.id === obj2.id
        })
      )
    })

    let result =
      uniqueResultTwo.length > 0 &&
      uniqueResultOne.concat(uniqueResultTwo.length > 0 && uniqueResultTwo)
    let shuffledResult = this.shuffle(result)
    return (
      <BlogListWrapper>
        {width <= 992 ? (
          <BlogListCategories
            width={width}
            subCategoriesDropdown={subCategoriesDropdown}
            toggleSubCategoriesDropdown={this.toggleSubCategoriesDropdown}
            categories={categories}
            path={path}
          />
        ) : null}
        <h2 className={Styles.section_title}>
          Блог постове с таг: <span>{data.tagName}</span>
        </h2>
        <BlogListWrapper>
          {width <= 992 ? (
            <div className={NewestBlogListStyle.list_holder}>
              <div className={NewestBlogListStyle.blogs_holder}>
                {data.posts &&
                  data.posts.map((blog, index) => (
                    <NewestBlogList blog={blog} key={index} />
                  ))}
              </div>
            </div>
          ) : (
            <div className={NewestBlogListStyle.list_holder}>
              <div className={NewestBlogListStyle.blogs_holder}>
                {data.posts &&
                  data.posts.map((blog, index) => (
                    <NewestBlogList blog={blog} key={index} />
                  ))}
              </div>
              <div className={NewestBlogListStyle.blog_categories_holder}>
                <BlogListCategories
                  width={width}
                  toggleSubCategoriesDropdown={this.toggleSubCategoriesDropdown}
                  subCategoriesDropdown={subCategoriesDropdown}
                  path={path}
                  categories={categories}
                />
                <div className={BlogListWrapperStyle.most_read_holder}>
                  <h2 className={BlogListWrapperStyle.most_read_title}>
                    Най-четени
                  </h2>
                  {shuffledResult &&
                    shuffledResult
                      .slice(0, 7)
                      .map((blog, index) => (
                        <MostReadBlogs blog={blog.node} key={index} />
                      ))}
                </div>
              </div>
            </div>
          )}
        </BlogListWrapper>
      </BlogListWrapper>
    )
  }
}

export default BlogTags
